import React from "react";

import styles from "./play-count.module.scss";

interface PlayCountProps {
  playCount: number;
}

export const PlayCount = ({ playCount }: PlayCountProps) => {
  return <div className={styles.playCount}>{playCount}</div>;
};
